module.exports = __webpack_public_path__ + "img/soccerfield.2aaf346f.png";